import { useSelector } from 'react-redux';

export default function useTourneyNextUpDetails(tempTableId) {
    const tourneyNextLevelUpDetails = useSelector((state) => state.gameTable.games[tempTableId]?.tourneyNextLevelUpDetails);

    if (!tourneyNextLevelUpDetails) {
        return {}
    }

    return tourneyNextLevelUpDetails
}
